<app-navbar></app-navbar>
<div class="container py-5">
    <h2 style="margin-bottom: 25px;">Cursos Básicos de Protección Radiológica</h2>
  <div class="row">
    <div class="col-md-12">
      <mat-card [appearance]="'outlined'">
        <mat-card-content>
          <p>
            La radiación ionizante está presente en diversas áreas como medicina, veterinaria, industria e investigación.
            La protección radiológica es esencial para garantizar la seguridad frente a sus efectos nocivos.
          </p>

          <p>
            Este curso forma parte de los requisitos del Ministerio de Salud según el Decreto Ejecutivo No. 44653-S,
            y está orientado a fomentar la cultura de seguridad radiológica en prácticas médicas, industriales y veterinarias.
          </p>

          <h4>Objetivos de aprendizaje</h4>
          <ul>
            <li>Conocer magnitudes dosimétricas y sus unidades.</li>
            <li>Familiarizarse con detectores de radiación y sus principios.</li>
            <li>Comprender efectos biológicos de la exposición a radiación.</li>
            <li>Conocer medidas generales de protección radiológica.</li>
            <li>Dominar la infraestructura reguladora y uso seguro de fuentes.</li>
          </ul>

          <h4>Docente responsable</h4>
          <p><strong>M.Sc. Dagoberto Eloy González López</strong></p>

          <h5>Formación académica</h5>
          <ul>
            <li>Ingeniería Nuclear - Instituto Superior de Tecnologías y Ciencias Aplicadas, Cuba (2013)</li>
            <li>Maestría en Física Médica - Universidad de Costa Rica (2020)</li>
          </ul>

          <h5>Experiencia laboral</h5>
          <ul>
            <li>Físico médico - Hospital México, CCSS (2021 - actualidad)</li>
            <li>Físico médico - Área de Control de Calidad y Protección Radiológica - CCSS (2018 - 2021)</li>
            <li>Físico médico - Radioterapia y Medicina Nuclear - Hospital Lenin, Cuba (2013 - 2016)</li>
          </ul>

          <h5>Colegios profesionales</h5>
          <ul>
            <li>CIEMI - CFIA (Código: IN-33322)</li>
            <li>Colegio de Físicos (Código: 245-17)</li>
          </ul>

          <p>
            Autorizado por el Ministerio de Salud bajo el código <strong>DPRSA-UPR-0168-2023-S</strong>,
            cédula de identidad N° 801480648.
          </p>

          <h4>Resultados esperados</h4>
          <ul>
            <li>Mejorar la comprensión en protección radiológica según el área de interés.</li>
            <li>Comprender la interacción de las radiaciones ionizantes con la materia.</li>
            <li>Reconocer los beneficios y los efectos biológicos de las radiaciones ionizantes.</li>
            <li>Aplicar las normas nacionales y recomendaciones internacionales.</li>
            <li>Implementar programas de aseguramiento de la calidad.</li>
          </ul>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
<app-footer></app-footer>